import { render, staticRenderFns } from "./CopyrightSelector.vue?vue&type=template&id=2186128c&scoped=true&"
import script from "./CopyrightSelector.vue?vue&type=script&lang=js&"
export * from "./CopyrightSelector.vue?vue&type=script&lang=js&"
import style0 from "./CopyrightSelector.vue?vue&type=style&index=0&id=2186128c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2186128c",
  null
  
)

export default component.exports